<template>
<div class="contentBox feedbackContentBox">
    <div class="messagesHeader">
        <h1>反馈</h1>
        <div class="searchBox" v-if="currentTab == 1">
            <input type="text" class="search" @focus="focusInput" @blur="inputBlur" v-model="searchVal" />
            <div :class="[searchFocus ? 'focus' : '', 'searchBtn']"></div>
          <button class="buyBtn" @click="openAdd">
            <img src="../../../assets/plusIcon.svg" alt />我要反馈
          </button>
        </div>

        <div class="searchBox" v-if="currentTab == 2">
            <input type="text" class="search" @focus="focusInputFb" @blur="inputBlurFb" v-model="searchValFb" />
            <div :class="[searchFocus ? 'focus' : '', 'searchBtn']"></div>
            <button class="buyBtn" @click="openAdd">
                <img src="../../../assets/plusIcon.svg" alt />我要反馈
            </button>
        </div>

        <div class="searchBox" v-if="currentTab == 3">
            <input type="text" class="search" @focus="focusInputComplain" @blur="inputBlurComplain" v-model="searchValComplain" />
            <div :class="[searchFocus ? 'focus' : '', 'searchBtn']"></div>
            <button class="buyBtn" @click="openAdd">
                <img src="../../../assets/plusIcon.svg" alt />我要反馈
            </button>
        </div>

    </div>

    <div class="tabsBox">
        <span :class="{ active: currentTab == 1 }" @click="changeTab(1)">我的反馈</span>
        <span :class="{ active: currentTab == 2 }" @click="changeTab(2)">观看反馈</span>
        <span :class="{ active: currentTab == 3 }" @click="changeTab(3)">观看举报</span>



    </div>


    <div class="myFeedBackMain" v-if="currentTab == 1">
        <div class="myFeedBackCon">
            <el-table :data="(myFeedBackData.slice((myFeedBackCurrentPage-1)*pageSize,myFeedBackCurrentPage*pageSize))" style="width: 100%" header-row-class-name="tableHeader">
                <el-table-column prop="title" label="标题" width="440"></el-table-column>
                <el-table-column prop="createTime" label="发起时间" >
<!--                    <template slot-scope="scope">
                        <span class="pageLink" @click="jumpPage(scope.row.url)">{{scope.row.createTime}}</span>
                    </template>-->
                </el-table-column>
                <el-table-column prop="reply" label="回复内容" align="center" width="440"></el-table-column>
                <el-table-column prop="replyTime" label="回复时间" align="center" ></el-table-column>
            </el-table>
        </div>

        <div class="paginationBox" v-if="myFeedBackData.length  > pageSize">
            <el-pagination @current-change="myFeedBackHandleCurrentChange" :current-page="myFeedBackCurrentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="myFeedBackCurrentTotal" prev-text="上一页" next-text="下一页"></el-pagination>
        </div>
    </div>
    <div class="watchFeedBackMain" v-if="currentTab == 2">
        <div class="watchFeedBackCon">
            <el-table :data="(watchFeedBackData.slice((watchFeedBackCurrentPage-1)*pageSize,watchFeedBackCurrentPage*pageSize))" style="width: 100%" header-row-class-name="tableHeader">
                <el-table-column prop="intro" label="反馈标题"></el-table-column>
                <el-table-column prop="targetName" label="反馈目标"></el-table-column>
                <el-table-column prop="createTime" label="时间" align="center" width="160"></el-table-column>
                <el-table-column prop="type" label="反馈类型" align="center" width="98">
                    <template slot-scope="scope">
                        <span>{{ ufTypes.getLabelByValue(scope.row.type) }}</span>
<!--                        <span>{{ scope.row.type | typeConvert }}</span>-->
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="操作" align="center" width="98">
                    <template slot-scope="scope">
                        <span class="delectIcon" @click="handleDelete(scope.$index, scope.row)"></span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="paginationBox" v-if="watchFeedBackData.length > pageSize">
            <el-pagination @current-change="watchFeedBackHandleCurrentChange" :current-page="watchFeedBackCurrentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="watchFeedBackCurrentTotal" prev-text="上一页" next-text="下一页"></el-pagination>
        </div>
    </div>

    <div class="watchFeedBackMain" v-if="currentTab == 3">
        <div class="watchFeedBackCon">
            <el-table :data="(watchComplainData.slice((watchComplainCurrentPage-1)*pageSize,watchComplainCurrentPage*pageSize))" style="width: 100%" header-row-class-name="tableHeader">
                <el-table-column prop="intro" label="举报标题"></el-table-column>
                <el-table-column prop="targetName" label="举报目标"></el-table-column>
                <el-table-column prop="createTime" label="时间" align="center" width="160"></el-table-column>
                <el-table-column prop="type" label="举报类型" align="center" width="98">
                    <template slot-scope="scope">
                        <span>{{ complainTypes.getLabelByValue(scope.row.type) }}</span>
                        <!--                        <span>{{ scope.row.type | typeConvert }}</span>-->
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="操作" align="center" width="98">
                    <template slot-scope="scope">
                        <span class="delectIcon" @click="handleDelete(scope.$index, scope.row)"></span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="paginationBox" v-if="watchComplainData.length > pageSize">
            <el-pagination @current-change="watchFeedBackHandleCurrentChange" :current-page="watchComplainCurrentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="watchComplainCurrentTotal" prev-text="上一页" next-text="下一页"></el-pagination>
        </div>
    </div>

    <el-dialog title="发起反馈" :visible.sync="dialogFormVisible" width="462px">
        <el-form :model="form" label-position="left">
            <el-form-item label="标题" :label-width="formLabelWidth">
                <el-input type="textarea" v-model="form.title" :rows="4" resize="none"></el-input>
            </el-form-item>
            <!--            <el-form-item label="标题" :label-width="formLabelWidth" class="w80">
                            <el-input v-model="form.title" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="流量" :label-width="formLabelWidth">
                            <el-input v-model="form.flow" autocomplete="off" class="w240"></el-input>
                        </el-form-item>
                        <el-form-item label="空间" :label-width="formLabelWidth">
                            <el-input v-model="form.space" autocomplete="off" class="w240"></el-input>
                        </el-form-item>
                        <el-form-item label="转码" :label-width="formLabelWidth">
                            <el-input v-model="form.duration" autocomplete="off" class="w240"></el-input>
                        </el-form-item>
                        <el-form-item label="有效期" :label-width="formLabelWidth">
                            <el-input v-model="form.validity" autocomplete="off" class="w240"></el-input>
                        </el-form-item>
                        <el-form-item label="价格" :label-width="formLabelWidth">
                            <el-input v-model="form.price" autocomplete="off" class="w240"></el-input>
                        </el-form-item>
                        <el-form-item label="系统保留" :label-width="formLabelWidth">
                            <el-switch v-model="form.type"></el-switch>
                        </el-form-item>
                        <el-form-item label="备注" :label-width="formLabelWidth">
                            <el-input type="textarea" v-model="form.intro" :rows="4" resize="none"></el-input>
                        </el-form-item>-->
        </el-form>
        <div slot="footer" class="dialog-footer">
            <button @click="save" class="savebtn">保存</button>
        </div>
    </el-dialog>

</div>
</template>

<script>
import common from "../../../../../sponsor/src/common";
import Enum from "../../../../../sponsor/src/Enum";

export default {
    name: "Feedback",
    data() {
        return {
            searchVal: '',
            searchValFb:'',
            searchValComplain:'',
            searchFocus: false,
            currentTab: "1",
            pageSize: 18,
            myFeedBackCurrentPage: 1,
            myFeedBackCurrentTotal: 0,
            myFeedBackData: [
                {
                    date: "2021-06-07 14:35",
                    name: "您的流量偏低，请尽快充值",
                    content: "首位发现贵州翻船事故的村民：救下9名学生",
                    terminal: "IOS",
                    url: "/live/list",
                },
            ],
            watchFeedBackCurrentPage: 1,
            watchFeedBackCurrentTotal: 0,
            watchFeedBackData: [{
                    date: "2021-06-07 14:35",
                    title: "首位发现贵州翻船事故的村民：救下9名学生",
                },
                {
                    date: "2021-06-07 14:35",
                    title: "首位发现贵州翻船事故的村民：救下9名学生",
                },
            ],
            watchComplainCurrentPage: 1,
            watchComplainCurrentTotal: 0,
            watchComplainData:[],
            dialogFormVisible: false,
            formLabelWidth: "80px",
            form: {
                title: "",

            },
            //反馈类型
            ufTypes : new Enum().add('ALL', '卡顿', 1)
                .add('SETTLE', '黑屏', 2)
                .add('SETTLED', '声音不同步', 3)
                .add('CANCEL', '其他', 9),
            //举报类型
            complainTypes : new Enum().add('ALL', '传播色情、暴力、反动等违法信息', 1)
                .add('SETTLE', '欺诈', 2)
                .add('SETTLED', '传销', 3)
                .add('SEE', '邪教', 4)
                .add('YOU', '侵权', 5)
                .add('CANCEL', '其他', 9),
        };
    },
    methods: {
        //加载我的反馈
        initTickling(){
            console.log(this.ufTypes);
            let _this = this;
            console.log(common.SPONSOR_TICKLING_LIST_URL);
            _this.$axios.post(common.SPONSOR_TICKLING_LIST_URL, this.$qs.stringify(
                {
                    pageNo: _this.myFeedBackCurrentPage,
                    pageSize:_this.pageSize,
                    searchKey:_this.searchVal
                    }
                )).then(function (res) {
                let r = res.data;
                if(parseInt(r.code) === 0 && r.data) {
                    console.log(r);
                    _this.myFeedBackData = r.data;
                    _this.myFeedBackCurrentTotal = r.count;

                }else{
                    _this.myFeedBackData = [];
                    _this.myFeedBackCurrentTotal = 0;
                    _this.$message({
                        message: '加载失败',
                        type: 'error'
                    });
                }
            });
        },
        //加载观众反馈
        initFeedback(){

            let _this = this;
            _this.$axios.post(common.FEEDBACK_LIST_URL, this.$qs.stringify(
                {
                    pageNo: _this.watchFeedBackCurrentPage,
                    pageSize:_this.pageSize,
                    searchKey:_this.searchValFb
                }
            )).then(function (res) {
                let r = res.data;
                if(parseInt(r.code) === 0 && r.data) {
                    console.log(r);
                    _this.watchFeedBackData = r.data;
                    _this.watchFeedBackCurrentTotal = r.count;

                }else{
                    _this.watchFeedBackData = [];
                    _this.watchFeedBackCurrentTotal = 0;
                    _this.$message({
                        message: '加载失败',
                        type: 'error'
                    });
                }
            });
        },
        //加载观众举报
        initComplain(){

            let _this = this;
            _this.$axios.post(common.COMPLAIN_LIST_URL, this.$qs.stringify(
                {
                    pageNo: _this.watchComplainCurrentPage,
                    pageSize:_this.pageSize,
                    searchKey:_this.searchValComplain
                }
            )).then(function (res) {
                let r = res.data;
                if(parseInt(r.code) === 0 && r.data) {
                    console.log(r);
                    _this.watchComplainData = r.data;
                    _this.watchComplainCurrentTotal = r.count;

                }else{
                    _this.watchComplainData = [];
                    _this.watchComplainCurrentTotal = 0;
                    _this.$message({
                        message: '加载失败',
                        type: 'error'
                    });
                }
            });
        },
        openAdd(){
            console.log('?')
            this.dialogFormVisible = true;
            this.form= {
                name: "",
                flow: "",
                space: "",
                duration: "",
                validity: "",
                price: "",
                type: false,
                intro: "",
            }
        },
        save(){
            let  _this = this;
            _this.$axios.post(common.ADD_TICKLING_URL, this.$qs.stringify({title:_this.form.title})).then(function (res) {
                let r = res.data;
                parseInt(r.code) < 0 && _this.jumpPage('/login');
                _this.$message({
                    message: '反馈成功',
                    type: 'success'
                });
                _this.initTickling();
                _this.dialogFormVisible = false;
            });
        },
        handleDelete(index, row) {
            this.watchFeedBackData.splice(index, 1);
            console.log(index, row);
            this.setWatchFeedBackCurrentTotal();
            if (this.watchFeedBackData.length != 0 && this.watchFeedBackData.slice((this.watchFeedBackCurrentPage - 1) * this.pageSize, this.watchFeedBackCurrentPage * this.pageSize).length == 0) {
                this.watchFeedBackCurrentPage -= 1;
            }
        },
        changeTab(tab) {
            this.currentTab = tab;
        },
        jumpPage(path) {
            this.$router.push(`${path}`);
        },
        focusInput() {
            this.searchFocus = true;
            this.initTickling();
        },
        inputBlur() {
            this.searchFocus = false;
            this.initTickling();
        },
        focusInputFb() {
            this.searchFocus = true;
            this.initFeedback();
        },
        inputBlurFb() {
            this.searchFocus = false;
            this.initFeedback();
        },
        focusInputComplain() {
            this.searchFocus = true;
            this.initComplain();
        },
        inputBlurComplain() {
            this.searchFocus = false;
            this.initComplain();
        },

        setMyFeedBackCurrentTotal() {
            this.myFeedBackCurrentTotal = this.myFeedBackData.length;
        },

        myFeedBackHandleCurrentChange(val) {
            this.myFeedBackCurrentPage = val;
            console.log(`当前页: ${val}`);
        },
        setWatchFeedBackCurrentTotal() {
            this.watchFeedBackCurrentTotal = this.watchFeedBackData.length;
        },

        watchFeedBackHandleCurrentChange(val) {
            this.watchFeedBackCurrentPage = val;
            console.log(`当前页: ${val}`);
        }
    },
    mounted() {
        this.initTickling();
        this.initFeedback();
        this.initComplain();
        this.setMyFeedBackCurrentTotal();
        this.setWatchFeedBackCurrentTotal();
    },
    filters:{
        /*typeConvert(type){
            //return Enum.typeEnum.getLabelByValue(type);
        }*/
    }
};
</script> 

<style lang="less">
.feedbackContentBox {
    .messagesHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        .searchBox {
            position: relative;

            .search {
                width: 437px;
                height: 40px;
                border: solid 1px #e8e8e8;
                background: #fff;
                border-radius: 6px;
                padding-left: 12px;
                margin-right: 50px;
            }
            .searchBtn{
              margin-right: 140px;
            }
        }
    }

    .pageLink {
        cursor: pointer;
    }

    .el-table__cell:hover {
        .pageLink {
            color: #306ff6;
        }

    }

    .tabsBox {
        border-bottom: solid 1px #306ff6;

        span {
            display: inline-block;
            width: 140px;
            height: 40px;
            border-radius: 6px 6px 0 0;
            background: #ffffff;
            text-align: center;
            line-height: 40px;
            font-size: 14px;
            margin-right: 15px;
            border: solid 1px #e8e8e8;
            border-bottom: none;
            color: #221816;
            cursor: pointer;
        }

        span.active {
            background: #306ff6;
            color: #fff;
            border: solid 1px #306ff6;
        }
    }

    .delectIcon {
        width: 12px;
        height: 13px;
        background: url("../../../assets/delete-gray.svg") 0 0 no-repeat;
        cursor: pointer;
        display: block;
        margin: 0 auto;
    }

    .delectIcon:hover {
        width: 12px;
        height: 13px;
        background: url("../../../assets/delete-blue.svg") 0 0 no-repeat;
        cursor: pointer;
        display: block;
        margin: 0 auto;
    }

    .tableHeader .cell {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #221816;

    }

    .el-table th.el-table__cell>.cell {
        padding-left: 20px;
    }

    .el-table .is-center .cell {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .buyBtn {

      width: 137px;
      height: 40px;
      background: #076eff;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      float: right;
      img {
        margin-right: 6px;
      }
    }

    .buyBtn:hover {
      background: #4aa3f8;
    }
    .el-dialog__header {
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0;
        padding-left: 17px;
        padding-right: 15px;
        background: #076eff;

        .el-dialog__title {
            color: #fff;
            font-size: 16px;
            font-weight: bold;
        }

        .el-dialog__headerbtn {
            top: 13px;
            right: 15px;
        }
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-weight: bold;
    }

    .el-dialog__body {
        padding-bottom: 0;
    }

    .el-dialog__footer {
        text-align: left;
        padding-left: 110px;
        padding-top: 0;
    }

    .savebtn {
        width: 110px;
        height: 30px;
        background: #076eff;
        border-radius: 4px;
        color: #fff;
        font-size: 14px;
    }

    .savebtn:hover {
        background: #4aa3f8;
    }

    .el-dialog__body {
        padding: 30px 52px 70px 40px;
    }

    .el-form-item,
    .el-form-item__content,
    .el-input,
    .el-input__inner,
    .el-form-item__label {
        height: 30px;
        line-height: 30px;
    }

    .el-form-item {
        margin-bottom: 13px;
    }

    .el-form-item__content {
        margin-left: 70px !important;
    }

    .el-form-item__label {
        width: 70px !important;
        color: #221816;
    }

}
</style>